export default __webpack_public_path__ + "media/images/logo-a9505392ce4f019ed50d2575438ebe46.svg";